import React from 'react';
import { FiberManualRecord, CheckCircle, ErrorOutline } from '@mui/icons-material';
import { keyframes } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';

const pulse = keyframes`
    0% { opacity: 0.6; transform: scale(0.95); }
    50% { opacity: 1; transform: scale(1.1); }
    100% { opacity: 0.6; transform: scale(0.95); }
`;

const shake = keyframes`
    0% { transform: translateX(0); }
    25% { transform: translateX(-2px); }
    50% { transform: translateX(2px); }
    75% { transform: translateX(-2px); }
    100% { transform: translateX(0); }
`;

const containerStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '36px',
    width: '28px',
};

const iconBaseSx = {
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
};

const UnsavedChangesDot = ({ hasUnsavedChanges, saving, failure }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    let tooltip = '';
    if (failure) {
        tooltip = t('general.failedToSave');
    } else if (!hasUnsavedChanges && !saving) {
        tooltip = t('general.allChangesSaved');
    } else {
        tooltip = t('general.hasUnsavedChangesSaving');
    }

    return (
        <Tooltip title={tooltip}>
            <span style={containerStyle}>
                {failure ? (
                    <ErrorOutline
                        sx={{
                            ...iconBaseSx,
                            color: theme.palette.error.main,
                            animation: `${shake} 0.5s ease-in-out infinite`,
                        }}
                    />
                ) : hasUnsavedChanges || saving ? (
                    <FiberManualRecord
                        sx={{
                            ...iconBaseSx,
                            color: theme.palette.warning.main,
                            animation: `${pulse} 1.5s ease-in-out infinite`,
                        }}
                    />
                ) : (
                    <CheckCircle
                        sx={{
                            ...iconBaseSx,
                            color: theme.palette.success.main,
                        }}
                    />
                )}
            </span>
        </Tooltip>
    );
};

export default UnsavedChangesDot;
